// extracted by mini-css-extract-plugin
export default {"titleWrapper":"RegistrationFormWrapper_titleWrapper__WUe3h","login":"RegistrationFormWrapper_login__9YJ7T"};